import React, { useState, useEffect } from 'react';
import { SiGithub } from 'react-icons/si';
import { IoEarth, IoNewspaperSharp } from 'react-icons/io5';
import { GrDeploy } from 'react-icons/gr';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/tnd/tools.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="Tools" className="tools">
            <h3>Tools Developed</h3>
            <ol>
                {content.map((item, index) => {
                    return (
                        <li key={index}>
                            <h5>
                                <a className="tool-title" target="blank" href={item.link}>
                                    {item.name}
                                </a>
                            </h5>
                            <p className="tool-desc">{item.description}</p>
                            {item.github && item.github.length > 0 ? (
                                <a className="tool-link" href={item.github} target="blank">
                                    <SiGithub />
                                </a>
                            ) : (
                                ''
                            )}
                            {item.website && item.website.length > 0 ? (
                                <a className="tool-link" href={item.website} target="blank">
                                    <IoEarth />
                                </a>
                            ) : (
                                ''
                            )}
                            {item.paper && item.paper.length > 0 ? (
                                <a className="tool-link" href={item.paper} target="blank">
                                    <IoNewspaperSharp />
                                </a>
                            ) : (
                                ''
                            )}
                            {item.deployment && item.deployment.length > 0 ? (
                                <a className="tool-link" href={item.deployment} target="blank">
                                    <GrDeploy />
                                </a>
                            ) : (
                                ''
                            )}
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default Component;
